// eslint-disable-next-line spaced-comment
export default ({ size, color = '#000' } = {}) => /*html*/`
  <svg width="${ size }" height="${ size }" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.09465 8.92395L2.7091 15.5117C2.40113 15.8294 1.90184 15.8294 1.5939 15.5117L0.849132 14.7434C0.54169 14.4262 0.541099 13.9121 0.847818 13.5942L5.90848 8.34867L0.847818 3.10318C0.541099 2.78526 0.54169 2.2712 0.849132 1.95402L1.5939 1.18566C1.90187 0.867942 2.40116 0.867942 2.7091 1.18566L9.09461 7.77343C9.40258 8.09112 9.40258 8.60623 9.09465 8.92395Z" fill="${ color }"/>
  </svg>
`
